import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SaveAccountPIN} from '../../../../shared/states/profile/profile.actions';
import {take, withLatestFrom} from 'rxjs/operators';
import {Select, Store} from '@ngxs/store';
import {ProfileState} from '../../../../shared/states/profile/profile.state';
import {Observable} from 'rxjs/internal/Observable';

@Component({
  selector: 'app-set-pin-dialog',
  templateUrl: './set-pin-dialog.component.html',
  styleUrls: ['./set-pin-dialog.component.scss'],
})
export class SetPinDialogComponent {
  @Input() isInvited: boolean;
  @Input() isDisabled: boolean;

  @Output() afterPinSet: EventEmitter<void> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();

  pinNumber = '';
  isInvalid: boolean;
  displayToggleInner: boolean;

  pinErrorMessage: string;

  hidePIN = true;
  inputsType = 'password';

  @Input() set displayToggle(value: boolean) {
    this.displayToggleInner = value;

    if (value) {
      this.hidePIN = false;
      this.inputsType = 'text';
    }
  }

  get displayToggle(): boolean {
    return this.displayToggleInner;
  }

  @Select(ProfileState.success) success$: Observable<boolean>;

  @ViewChild('pinInput') pinInput;
  @ViewChild('setPinButton') setPinButton;

  constructor(
    private store: Store,
  ) {
  }

  updatePin(value: string): void {
    this.pinNumber = value;
    this.pinErrorMessage = '';
    setTimeout(() => this.setPinButton.focus());
  }

  setPin(): void {
    this.isDisabled = true;

    this.store.dispatch(new SaveAccountPIN(this.pinNumber))
      .pipe(take(1), withLatestFrom(this.success$))
      .subscribe(([_, success]) => {
        this.isInvalid = !success;
        this.isDisabled = false;

        if (success) {
          this.afterPinSet.emit();
        } else {
          this.isInvalid = false;
          this.pinErrorMessage = 'You must choose a different PIN.';

          if (this.pinInput?.pinInputList) {
            setTimeout(() => this.pinInput.clearInputs());
          }
        }
      });
  }

  back(): void {
    this.cancel.emit();
  }

  togglePIN(): void {
    this.hidePIN = !this.hidePIN;
    this.inputsType = this.inputsType === 'password' ? 'text' : 'password';
  }
}
